<meta name="viewport" content="width=device-width, initial-scale=1"></meta>

<template>
  <v-content>
  <v-container >
    <div class="block text-center notFound">
      <h2>Página no encontrada</h2>
      <i class="fas fa-exclamation-triangle red--text"></i>
      <p>Lo sentimos, pero esta página no está disponible</p>
    </div>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: "NotFound",
};
</script>